(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.videoPoster = {
        attach: function (context, settings) {
            var containers = context.querySelectorAll('.video-section, .image-text__image');
            containers.forEach(function (c) {
                if (once('video-poster', c).length === 0) return;
                var poster = c.querySelector('.video-poster');
                var videoEl = c.querySelector('.video-element');
                if (!poster || !videoEl) return;
                var source = videoEl.querySelector('source');
                if (!source) return;
                var videoSrc = poster.getAttribute('data-video-src');

                function loadAndPlay() {
                    if (!videoSrc) return;
                    source.setAttribute('src', videoSrc);
                    videoEl.style.display = '';
                    poster.style.display = 'none';
                    videoEl.load();
                    var playPromise = videoEl.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(function () {});
                    }
                }

                poster.addEventListener('click', loadAndPlay);
                poster.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        loadAndPlay();
                    }
                });
            });
        }
    };
})(Drupal, once);
